import {
   Button,
   FormControl,
   FormLabel,
   Input,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalContent,
   ModalFooter,
   ModalHeader,
   ModalOverlay,
   Switch,
   useToast
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import ContractService from 'services/contracts';
import { Vehicle } from '../../types'; // <- importante

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  vehicleEdit?: Vehicle | null; // novo
}

export function VehicleCreateModal({
  isOpen,
  onClose,
  onSuccess,
  vehicleEdit
}: Props) {
  const toast = useToast();
  const [marca, setMarca] = useState('');
  const [modelo, setModelo] = useState('');
  const [ativo, setAtivo] = useState(true);
  const [loading, setLoading] = useState(false);

  // 🔹 Preenche campos quando abrir em modo edição
  useEffect(() => {
    if (vehicleEdit) {
      setMarca(vehicleEdit.marca || '');
      setModelo(vehicleEdit.modelo || '');
      setAtivo(vehicleEdit.ativo === 'Sim');
    } else {
      setMarca('');
      setModelo('');
      setAtivo(true);
    }
  }, [vehicleEdit, isOpen]);

  const handleSubmit = async () => {
    if (!marca.trim() || !modelo.trim()) {
      toast({
        title: 'Campos obrigatórios',
        description: 'Preencha os campos de marca e modelo.',
        status: 'warning',
        position: 'bottom-left',
        isClosable: true
      });
      return;
    }

    try {
      setLoading(true);

      if (vehicleEdit?.guid) {
        // 🔹 Edição
        await ContractService.updateVehicle(vehicleEdit.guid, {
          marca,
          modelo,
          ativo
        });
        toast({
          title: 'Veículo atualizado com sucesso!',
          status: 'success',
          position: 'bottom-left',
          isClosable: true
        });
      } else {
        // 🔹 Criação
        await ContractService.createVehicle({
          marca,
          modelo,
          ativo
        });
        toast({
          title: 'Veículo cadastrado com sucesso!',
          status: 'success',
          position: 'bottom-left',
          isClosable: true
        });
      }

      onClose();
      onSuccess();
    } catch (error: any) {
      const response = error.response;
      const errorMessage =
      Array.isArray(response?.data)
      ? response.data[0]?.mensagem
      : response?.data?.mensagem || response?.data?.message || 
        'Verifique os dados e tente novamente.';

      toast({
        title: 'Erro ao salvar veículo',
        description: errorMessage,
        status: 'error',
        position: 'bottom-left',
        isClosable: true
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {vehicleEdit ? 'Editar Veículo' : 'Novo Veículo'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={3}>
            <FormLabel>Marca</FormLabel>
            <Input
              value={marca}
              onChange={(e) => setMarca(e.target.value)}
            />
          </FormControl>

          <FormControl mb={3}>
            <FormLabel>Modelo</FormLabel>
            <Input
              value={modelo}
              onChange={(e) => setModelo(e.target.value)}
            />
          </FormControl>

          <FormControl display="flex" alignItems="center">
            <FormLabel mb="0">Ativo</FormLabel>
            <Switch
              isChecked={ativo}
              onChange={(e) => setAtivo(e.target.checked)}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button variant="outline" onClick={onClose} mr={3}>
            Cancelar
          </Button>
          <Button
            colorScheme="primary"
            onClick={handleSubmit}
            isLoading={loading}
          >
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
